// SPDX-License-Identifier: AGPL-3.0-or-later

export const BANNED_POSTER = `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 240"><circle cx="240" cy="120" r="68" fill="none" stroke="#dc4545" stroke-width="14"/><path d="m192 72 96 96" stroke="#dc4545" stroke-width="14"/></svg>')}`;
